import useGradesTableStore from '../store/useGradesTableStore';
import useAssessmentExerciseResults from './queries/exerciseResults/useAssessmentExerciseResults';
import { useAllAssessmentQuestionAnswers } from './queries/questionAnswers/useAssessmentQuestionAnswers';
import useAssignmentQuestionAnswers from './queries/questionAnswers/useAssignmentQuestionAnswers';
import useGames from './queries/exerciseResults/useGames';
import useLessonNotebooks from './queries/exerciseResults/useLessonNotebooks';
import useReadingGameExerciseResults from './queries/exerciseResults/useReadingGameExerciseResults';
import useReferenceMaterialExerciseResults from './queries/exerciseResults/useReferenceMaterialExerciseResults';
import useSectionNotebookExerciseResults from './queries/exerciseResults/useSectionNotebookExerciseResults';
import useSectionNotebooksQuestionAnswers from './queries/questionAnswers/useSectionNotebooksQuestionAnswers';
import useSubmissions from './queries/useSubmissions';
import useUnitProjectExerciseResults from './queries/exerciseResults/useUnitProjectExerciseResults';
import useVideoActivityExerciseResult from './queries/exerciseResults/useVideoActivityExerciseResult';
import useVideoActivityQuestionAnswers from './queries/questionAnswers/useVideoActivityQuestionAnswers';

// AIDEV-NOTE: score queries only — the structural ones live in useIsStructureLoading. Keep this
// called above the loading gate so scores fetch in parallel with structure rather than after it.
const useGradesTableData = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const lesson = useGradesTableStore(state => state.lesson);

  useAssessmentExerciseResults(classroom, lesson);
  useAllAssessmentQuestionAnswers();
  useAssignmentQuestionAnswers();
  useGames();
  useLessonNotebooks();
  useReadingGameExerciseResults();
  useReferenceMaterialExerciseResults(classroom, lesson);
  useSectionNotebookExerciseResults();
  useSectionNotebooksQuestionAnswers();
  useSubmissions();
  useUnitProjectExerciseResults();
  useVideoActivityExerciseResult(classroom, lesson);
  useVideoActivityQuestionAnswers();
};

export default useGradesTableData;
